import { ContractLandingComponent } from './contract-landing.component';

export const containers: any[] = [ContractLandingComponent];

export * from './contract-landing.component';
